(function () {
  var root = document.documentElement;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var lenis = null;
  var rafId = null;

  var preventSelectors = [
    '[data-lenis-prevent]',
    '[aria-modal="true"]',
    'dialog',
    '.modal',
    '.modal__content',
    '.cart-drawer',
    '.drawer',
    '.menu-drawer',
    '.menu-drawer__inner-container',
    '.facets__display',
    '.slider',
    '.slider-component',
    '.product__media-list',
    'input',
    'textarea',
    'select'
  ].join(',');

  function isThemeEditor() {
    return Boolean(window.Shopify && window.Shopify.designMode);
  }

  function canStart() {
    return !isThemeEditor() && !reducedMotion.matches && typeof window.Lenis === 'function';
  }

  function shouldPreventSmoothScroll(node) {
    return Boolean(node && node.closest && node.closest(preventSelectors));
  }

  function start() {
    if (lenis || !canStart()) return;

    lenis = new window.Lenis({
      autoRaf: false,
      autoResize: true,
      anchors: {
        offset: -96
      },
      gestureOrientation: 'vertical',
      lerp: 0.075,
      orientation: 'vertical',
      smoothWheel: true,
      stopInertiaOnNavigate: true,
      syncTouch: false,
      touchMultiplier: 1,
      wheelMultiplier: 0.9,
      prevent: shouldPreventSmoothScroll
    });

    window.fsLenis = lenis;
    root.dataset.fsSmoothScroll = 'active';

    function raf(time) {
      if (!lenis) return;
      lenis.raf(time);
      rafId = window.requestAnimationFrame(raf);
    }

    rafId = window.requestAnimationFrame(raf);
  }

  function stop() {
    if (rafId) {
      window.cancelAnimationFrame(rafId);
      rafId = null;
    }

    if (lenis && typeof lenis.destroy === 'function') {
      lenis.destroy();
    }

    lenis = null;
    window.fsLenis = null;
    delete root.dataset.fsSmoothScroll;
  }

  function handleMotionChange() {
    if (reducedMotion.matches) {
      stop();
      return;
    }

    start();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  if (typeof reducedMotion.addEventListener === 'function') {
    reducedMotion.addEventListener('change', handleMotionChange);
  } else if (typeof reducedMotion.addListener === 'function') {
    reducedMotion.addListener(handleMotionChange);
  }

  document.addEventListener('shopify:section:load', function () {
    if (lenis && typeof lenis.resize === 'function') lenis.resize();
  });

  document.addEventListener('shopify:section:unload', function () {
    if (lenis && typeof lenis.resize === 'function') lenis.resize();
  });

  window.addEventListener('pagehide', stop);
})();
